import useGetDiagnosisCategories from '@/hooks/telemedicine/useGetDiagnosisCategories';
import { DepartmentCategoryModel } from '@/models/diagnosis/category';

export interface DiseaseEncyclopediaSelectSubjectViewModel {
  departmentCategories: DepartmentCategoryModel[];
}

const useDiseaseEncyclopediaSelectSubjectViewModel = (): DiseaseEncyclopediaSelectSubjectViewModel => {
  const { categoriesInfo } = useGetDiagnosisCategories();
  const departmentCategories = categoriesInfo.getDepartmentCategories();

  return {
    departmentCategories,
  };
};

export default useDiseaseEncyclopediaSelectSubjectViewModel;
